import { useEffect, useContext } from "react";
// PERBAIKAN: Tambahkan kurung kurawal { } di sekitar useJWT
import JWTContext from "../../context/JWTContext";

export const LogoutSeller = () => {
  const { logout: logoutAccount } = useContext(JWTContext);

  useEffect(() => {
    logoutAccount();
    window.location.href = "/admin/login";
  }, []);

  return <div>Logging out...</div>;
};
